// customizationOptions.js

const customizationOptions = [
  {
    meshName: 'customLogo',
    materialName: 'customLogo',
    textures: [null],
    colors: ['0xffffff'],
  }   
];

export { customizationOptions };